import React, { useRef, useState } from "react";
import styles from "./SellConfirm.module.scss";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import InputFormik from "../../../Formik/Input/InputFormik";
import Button from "../../../Button/Button";
import { formatPrice } from "../../../../../utils/utils";
import Modal from "../../Modal/Modal";
import Select from "../../../Formik/Select/Select";
import { useDispatch } from "react-redux";
import { getSellWithUsTokenPricesAction, getTokenBalanceAction, saveTokeBalance } from "../../../../../features/user/userSlice";
import { assetOptions } from "../../../../../utils/constants";
import { toFix } from "../../../../../utils/utils";
import { formattedPrice } from "../../../../../utils/utils";

const SellConfirm = ({
  show,
  handleClose,
  handleSellConfirm,
  selectedAsset,
  activeTab,
  title,
  handleAssetTypeChange,
  quantity,
  formik,
  buyPrices,
  setBuyPrices,
  updatedAssetOptions = [],
  coinList,
}) => {
  const [localTokenBalance, setLocalTokenBalance] = useState(0);
  const tokenBalance = useSelector((state) => state?.users?.tokenBalance);
  const dispatch = useDispatch();
  const [decimalLimit, setDecimalLimit] = useState();
  const [inputValue, setInputValue] = useState("");
  const [minOrderQty, setMinOrderQty] = useState(0);
  const [total, setTotal] = useState(0);
  // const calculateTotal = () => {
  //   const totalPrice = Number(quantity) * Number(buyPrices);
  //   setTotal(totalPrice);
  // };
  const calculateTotal = () => {
    const qty = Number(quantity);
    const price = Number(buyPrices);

    if (!isNaN(qty) && !isNaN(price) && price > 0) {
      setTotal(qty * price);
    } else {
      setTotal(0);
    }
  };

  const timeOptions = [
    { label: "Order By Qty", value: "WEEK", timeUnit: "day", count: 1, },
    { label: "Order By Value", value: "DAY", timeUnit: "hour", count: 2, },
    // { label: "Monthly", value: "MONTH", timeUnit: "month", count: 1,},
  ];
  const [filter, setFilter] = useState(timeOptions[0]);
  const descriptionRef = useRef(null);

  useEffect(() => {
    const selectedCoin = coinList.find(
      (coin) => coin?.coin_symbol === selectedAsset?.label
    );
    if (selectedCoin?.quantity_decimal !== null) {
      setDecimalLimit(selectedCoin?.quantity_decimal);
      setMinOrderQty(selectedCoin?.min_order_qty);
    }
  }, [coinList, selectedAsset]);

  const isConfirmDisabled = () => {
    const qty = Number(formik.values.quantity);

    // Disable if quantity is not a number or less than the min order qty
    return isNaN(qty) || qty < minOrderQty;
  };


  useEffect(() => {
    calculateTotal();
  }, [quantity, buyPrices]);

  useEffect(() => {
    if (show && selectedAsset && activeTab === "sellUs") {
      dispatch(getTokenBalanceAction({ tokenId: selectedAsset?.value }));
    }
  }, [show, selectedAsset, activeTab, dispatch]);

  useEffect(() => {
    if (show && activeTab === "sellUs") {
      setLocalTokenBalance(0);
    }
  }, [show, activeTab]);

  useEffect(() => {
    if (activeTab === "sellUs" && tokenBalance !== undefined) {
      setLocalTokenBalance(tokenBalance);
    }
  }, [tokenBalance, activeTab]);

  // useEffect(() => {
  //   if (show && selectedAsset) {
  //     dispatch(
  //       getSellWithUsTokenPricesAction({ tokenId: selectedAsset?.value })
  //     );
  //   }
  // }, [show, selectedAsset, dispatch]);

  // useEffect(() => {
  //   const calculateTotal = () => {
  //     const totalPrice = Number(formik.values.quantity) * Number(buyPrices);
  //     setTotal(totalPrice);
  //   };

  //   calculateTotal();
  // }, [formik.values.quantity, buyPrices]);

  // useEffect(() => {
  //   const selectedOption = updatedAssetOptions?.find(
  //     (option) => option.value === selectedAsset?.value
  //   );
  //   if (selectedOption) {
  //     setBuyPrices(selectedOption.calculatedBuyPrice);
  //   }
  // }, [selectedAsset, updatedAssetOptions]);

  useEffect(() => {
    const selectedOption = updatedAssetOptions?.find(
      (option) => option.value === selectedAsset?.value
    );

    if (selectedOption) {
      setBuyPrices(selectedOption.calculatedBuyPrice);

      // Only update quantity if price is valid
      if (
        filter.label === "Order By Value" &&
        inputValue !== "" &&
        !isNaN(Number(inputValue)) &&
        Number(selectedOption.calculatedBuyPrice) > 0
      ) {
        const newQty =
          Number(inputValue) / Number(selectedOption.calculatedBuyPrice);
        formik.setFieldValue("quantity", newQty.toFixed(decimalLimit));
      }
    }
  }, [selectedAsset, updatedAssetOptions]);

  return (
    <>
      {/* <Modal
        className={styles.buy_modal}
        show={show}
        handleClose={handleClose}
        title={title}
      > */}
      <div className={styles.buy_modal}>
        <ul>
          <li>
            <div className={`${styles.buy_module_asset} ${styles.mb_16}`}>
              <div className={styles.buy_module_asset_header}>
                <h6 className={styles.select_asset}>Select Asset</h6>
                <h6 className={styles.balance}>
                  Bal: <span>{toFix(Number(localTokenBalance), 3)} ozt</span>
                </h6>
              </div>
              <Select
                options={updatedAssetOptions}
                value={selectedAsset}
                onChange={handleAssetTypeChange}
                variant="large_height"
                selected={selectedAsset}
                isSearchable={false}
              />
            </div>
          </li>
          {/* <li>
            <h6>Quantity</h6>
            <h4>
              <InputFormik
                variant="dark"
                placeholder="Enter Quantity"
                value={quantity}
                onChange={handleQuantityChange}
                maxLength={6}
              />
            </h4>
          </li> */}

          <li>
            <div className={`${styles.buy_module_asset} ${styles.mb_16}`}>
              <div className={styles.buy_module_asset_header}>
                {/* <h6>Quantity</h6> */}
                <h6>
                  {filter.label === "Order By Qty"
                    ? "Quantity"
                    : "Enter Value ($)"}
                </h6>
              </div>
              {/* <h4> */}
              <InputFormik
                type="text"
                name="quantity"
                variant="large_height"
                className='iconrightSide'
                placeholder={
                  filter.label === "Order By Qty"
                    ? "Enter Quantity"
                    : "Enter Value"
                }
                value={inputValue}
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = new RegExp(`^(\\d+)?(\\.\\d{0,${decimalLimit}})?$`);
                  if (value === "" || regex.test(value)) {
                    setInputValue(value);
                    if (filter.label === "Order By Qty") {
                      formik.setFieldValue("quantity", value);
                    } else if (Number(buyPrices) > 0) {
                      const qty = Number(value) / Number(buyPrices);
                      formik.setFieldValue(
                        "quantity",
                        qty.toFixed(decimalLimit)
                      );
                    } else {
                      formik.setFieldValue("quantity", ""); // Prevent NaN
                    }
                  }
                }}
                maxLength={8}
                icon={
                  <Select
                    isSearchable={false}
                    options={timeOptions}
                    value={filter}
                    placeholder={<h5>Weekly</h5>}
                    className={styles.select_time}
                    onChange={(selected) => {
                      setFilter(selected);

                      // Reset on filter change
                      setInputValue("");
                      formik.setFieldValue("quantity", "");
                    }}
                  />
                }
              />
              <Button
                className={styles.btn_max}
                variant='xtra_small'
                onClick={() => {
                  const maxQty = Number(localTokenBalance);
                  const truncatedQty = Math.floor(maxQty * Math.pow(10, decimalLimit)) / Math.pow(10, decimalLimit);

                  if (filter.label === "Order By Qty") {
                    setInputValue(truncatedQty.toString());
                    formik.setFieldValue("quantity", truncatedQty.toString());
                  } else if (Number(buyPrices) > 0) {
                    const maxValue = truncatedQty * Number(buyPrices);
                    setInputValue(maxValue.toFixed(2));
                    formik.setFieldValue("quantity", truncatedQty.toString());
                  }
                }}
              >
                Max
              </Button>




              {formik.errors.quantity && (
                <p style={{ color: "white" }}>{formik.errors.quantity}</p>
              )}
              {formik.values.quantity &&
                Number(formik.values.quantity) < minOrderQty && (
                  <p style={{ color: "red", marginTop: "4px" }}>
                    Minimum quantity should be {minOrderQty} ozt
                  </p>
                )}

              {/* </h4> */}
            </div>
          </li>

          <li>
            <h6>At Price</h6>
            {/* <h4>{formattedPrice(toFix(buyPrices, 5))}</h4> */}
            <h4>{formattedPrice(Number(buyPrices))}</h4>
            {/* <h4>${Number(formattedPrice((buyPrices, 5)))}</h4> */}
          </li>
          {/* <li>
            <h6>Total</h6>
            <h4>{formattedPrice(Number(total))}</h4>
            
          </li> */}
          <li>
            <h6>{filter.label === "Order By Qty" ? "Total" : "Quantity"}</h6>
            <h4>
              {filter.label === "Order By Qty"
                ? isNaN(total) || Number(buyPrices) === 0
                  ? "$0.00"
                  : formattedPrice(Number(total))
                : isNaN(Number(formik.values.quantity))
                  ? "0.00 ozt"
                  : `${toFix(formik.values.quantity, decimalLimit)} ozt`}
            </h4>
          </li>
        </ul>
        <Button
          fluid
          className={styles.submit_btn}
          onClick={handleSellConfirm}
          disabled={isConfirmDisabled()}
        >
          Confirm Sell
        </Button>
      </div>
      {/* </Modal> */}
    </>
  );
};

export default SellConfirm;
